import React from 'react'
import { isEmpty, round } from 'lodash'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import PieChart from '../../../components/charts/PieChart'

const useStyles = makeStyles(theme => ({
  gridContainer: {
    fontSize: '1rem',
    padding: '0px 10px'
  },
  valueColor: {
    color: '#283593'
  },
  borderGrid: {
    border: '1px solid rgba(224, 224, 224, 1)',
    borderRadius: '4px',
    padding: 0
  }
}))

const colorScheme = ['#673ab7', '#4caf50', '#03a9f4', '#f44336', '#ffc107', '#795548', '#9e9e9e']

function GeneralFee(props) {
  const classes = useStyles()
  const { data, paymentsChannelsData } = props
  const chartHeight = 50 + paymentsChannelsData.length * 40
  const { accrued, paid, debt_start, debt_end } = data
  const numAccrued = Number(accrued)
  const numPaid = Number(paid)
  const taxPercent = numPaid !== 0 && numAccrued !== 0 ? round((numPaid * 100 / numAccrued), 2) : numPaid !== 0 ? 100 : 0

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Grid className={classes.gridContainer} container>
          <Grid item xs={12}>Долг на начало: <span className={classes.valueColor}>{round(debt_start, 2).toLocaleString()} руб.</span></Grid>
          <Grid item xs={12}>Начислено: <span className={classes.valueColor}>{numAccrued.toLocaleString()} руб.</span></Grid>
          <Grid item xs={12}>Оплачено: <span className={classes.valueColor}>{numPaid.toLocaleString()} руб.</span></Grid>
          <Grid item xs={12}>Долг на конец: <span className={classes.valueColor}>{round(debt_end, 2).toLocaleString()} руб.</span></Grid>
          <Grid item xs={12}>Сбор: <span className={classes.valueColor}>{taxPercent.toLocaleString()}%</span></Grid>
          <Grid item xs={12}>Показатель фин. устойчивости: <span className={classes.valueColor}>{numAccrued !== 0 ? round(debt_end / numAccrued, 2).toFixed(2).replace('.', ',') : 0}</span></Grid>
          <Grid item xs={12}>Показатель ДМ: <span className={classes.valueColor}>{numAccrued + debt_start !== 0 ? round(2 * numPaid / (numAccrued + debt_start), 2).toFixed(2).replace('.', ',') : 0}</span></Grid>
        </Grid>
      </Grid>
      <Grid item xs={8} className={classes.borderGrid}>
        {!isEmpty(paymentsChannelsData)
          ?
          <PieChart
            data={paymentsChannelsData}
            height={145}
            colorScheme={colorScheme}
            valueField='payments'
            argumentField='channel'
            legend={true}
            isTitled={false}
          />
          :
          <Grid container style={{height: '100%', alignItems: 'center', justifyContent: 'center', color: 'gray'}}>
            <Grid item>Отсутствуют данные</Grid>
          </Grid>
        }
      </Grid>
    </Grid>
  )
}

export default GeneralFee
